export const truncateText = (text: string, maxLength: number = 30): string => {
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const shouldShowTooltip = (text: string, maxLength: number = 30): boolean => {
  return text.length > maxLength;
};


